﻿/**
 * BreadCrumbs
 * 
 * @class rlBreadCrumbs
 * @memberOf jQuery.fn
 */

(function ($) {
    $.fn.rlBreadCrumbs = function () {
       function breadcrumbWidth() {
          var breadwidthcalc = 0;
          //work out combined width of child elements
          $('ol.breadcrumb li').each(function () { breadwidthcalc += $(this).width(); });

          //add up calculation by 100 and trim to decimal point
          var breadwidthroundup = breadwidthcalc + 100;
          var breadwidthtrim = breadwidthroundup.toFixed(0);

          //apply width parent breadcrumb element
          $('ol.breadcrumb').css('width', breadwidthtrim);
       }

       var rlBreadWidth;
       rlBreadWidth = (function () {

          let stateCheck = setInterval(() => {
             if (document.readyState === 'complete') {
                clearInterval(stateCheck);

                elem = document.getElementById("main-content");
                let resizeObserver = new ResizeObserver(() => {

                   setTimeout(breadcrumbWidth, 250);

                });
                resizeObserver.observe(elem);
             }
          }, 250);
       });

       breadcrumbWidth();
       rlBreadWidth();
    }
}(jQuery));